import { ApiRequest } from "src/models/api.request";
import VwKullaniciRolyetkiDTO from "src/models/RolYetki/VwKullaniciRolyetkiDTO";
import api from "src/services/core/api";

const controllerName = "VwKullaniciRolyetkiDTO";

export const kullaniciRolYetkiApi = api.injectEndpoints({
    endpoints: builder => ({
        getVwKullaniciMenuyetki: builder.query<Array<VwKullaniciRolyetkiDTO>, number>({
            query: (userId) => {
                var apiRequest: ApiRequest<VwKullaniciRolyetkiDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            { fieldName: 'kullaniciId', operator: '=', value1: userId },
                            { fieldName: 'yetkili', operator: '=', value1: 'E' },
                            { fieldName: 'yetkitipi', operator: '=', value1: 17 }
                        ]
                    },
                    sorts: [{ fieldName: 'treekey' }]
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: apiRequest
                }
            },
            providesTags: ["MenuAuth"]
        }),
        getVwKullaniciKontrolyetki: builder.query<Array<VwKullaniciRolyetkiDTO>, number>({
            query: (userId) => {
                var apiRequest: ApiRequest<VwKullaniciRolyetkiDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            { fieldName: 'kullaniciId', operator: '=', value1: userId },
                            { fieldName: 'yetkili', operator: '=', value1: 'E' },
                            { fieldName: 'yetkitipi', operator: '=', value1: 18 }
                        ]
                    },
                    sorts: [{ fieldName: 'treekey' }]
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: apiRequest
                }
            },
            providesTags: ["ControlAuth"]
        })
    }),
})

export const { useGetVwKullaniciKontrolyetkiQuery, useGetVwKullaniciMenuyetkiQuery } = kullaniciRolYetkiApi;